import { useState, useEffect } from "react";
import ScoreStyles from "./css_modules/ScoreStyles.module.css";
import { useTranslation } from "react-i18next";

const Score = ({ score }) => {
    // Состояние для текущего счета
    const [highScore, setHighScore] = useState(0);
    const [leaderboard, setLeaderboard] = useState([]);
    const { t } = useTranslation();


    // Загружаем рекорд из локального хранилища при монтировании компонента
    useEffect(() => {
        const savedHighScore = localStorage.getItem("highScore");
        if (savedHighScore) {
            setHighScore(Number(savedHighScore));
        }
    }, []);

    // Обновляем рекорд, если текущий счет больше сохраненного рекорда
    useEffect(() => {
        if (score > highScore) {
            setHighScore(score);
            localStorage.setItem("highScore", score); // Сохраняем новый рекорд в локальное хранилище
        }
    }, [score, highScore]);


    // Обновляем рекорд и отправляем в таблицу лидеров, если текущий счёт больше сохранённого
    useEffect(() => {
        if (score > highScore) {
            setHighScore(score);
            localStorage.setItem("highScore", score);

            // Отправляем новый рекорд в таблицу лидеров
            submitToLeaderboard(score);
        }
    }, [score, highScore]);

    // Отправка счёта в таблицу лидеров
    const submitToLeaderboard = async (currentScore) => {
        try {
            if (window.sdk) {
                await window.sdk.getLeaderboards().setLeaderboardScore("Records", currentScore);
                console.log("Результат отправлен:", currentScore);
                refreshLeaderboard(); // Обновляем таблицу лидеров
            }
        } catch (error) {
            console.error("Ошибка отправки результата:", error);
        }
    };

    // Загрузка таблицы лидеров
    const refreshLeaderboard = async () => {
        try {
            if (window.sdk) {
                const leaderboardData = await window.sdk.getLeaderboards().getLeaderboardEntries("Records", {
                    includeUser: true,
                    quantityTop: 10,
                    quantityAround: 5,
                });
                setLeaderboard(leaderboardData.entries || []);
            }
        } catch (error) {
            console.error("Ошибка получения таблицы лидеров:", error);
        }
    };

    // Загружаем таблицу лидеров при монтировании компонента
    useEffect(() => {
        refreshLeaderboard();
    }, []);


    return (
        <div className={ScoreStyles.scoreContainer}>
            <div>{t('score')}</div>
            <div className={ScoreStyles.score}>{score}</div>
            <div>{t('highScore')}</div>
            <div className={ScoreStyles.score}>{highScore}</div>
            <div className={ScoreStyles.leaderboard}>
                <h3>{t('tableScore')}</h3>
                <ul>
                    {leaderboard.map((entry, index) => (
                        <li key={index}>
                            {entry.rank}. {entry.player.publicName || `${t('tableScore')}`}: {entry.score}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default Score;


